import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * This service manages the tracking of the previous URL visited.
 * It provides a way to set and observe the previous URL.
 */
@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private previousUrl: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);
  public previousUrl$: Observable<string | null> =
    this.previousUrl.asObservable();

  setPreviousUrl(previousUrl: string | null) {
    this.previousUrl.next(previousUrl);
  }
}
